// eslint-disable-next-line import/no-commonjs
const { DeviceClass, NonNmsDeviceClass, AllDeviceClass } = require('@kentik/ui-shared/nms/deviceMetadata');

const NmsDeviceClassLabel = {
  [DeviceClass.AccessPoint]: 'Access Point',
  [DeviceClass.Firewall]: 'Firewall',
  [DeviceClass.LoadBalancer]: 'Load Balancer',
  [DeviceClass.NetworkInterfaceDevice]: 'Network Interface Device',
  [DeviceClass.OpticalTransport]: 'Optical Transport',
  [DeviceClass.PDU]: 'Power Distribution Unit',
  [DeviceClass.Router]: 'Router',
  [DeviceClass.SdwanGateway]: 'SD-WAN Gateway',
  [DeviceClass.Server]: 'Server',
  [DeviceClass.StorageArray]: 'Storage Array',
  [DeviceClass.Switch]: 'Switch',
  [DeviceClass.UPS]: 'Uninterruptible Power Supply',
  [DeviceClass.WirelessController]: 'Wireless Controller',
  [DeviceClass.SecurityAppliance]: 'Security Appliance'
};

const NonNmsDeviceClassLabel = {
  [NonNmsDeviceClass.Flow]: 'Flow',
  [NonNmsDeviceClass.FlowIcmp]: 'Flow + ICMP',
  [NonNmsDeviceClass.Icmp]: 'ICMP'
};

const AllDeviceClassLabel = {
  ...NmsDeviceClassLabel,
  ...NonNmsDeviceClassLabel
};

const getDeviceClassFilterOptions = () => {
  const nmsClasses = Object.values(DeviceClass).map((deviceClass) => ({
    label: NmsDeviceClassLabel[deviceClass],
    value: deviceClass
  }));

  const nonNmsClasses = Object.values(NonNmsDeviceClass).map((deviceClass) => ({
    label: NonNmsDeviceClassLabel[deviceClass],
    value: deviceClass
  }));

  return nmsClasses.concat(nonNmsClasses);
};

const DeviceCapability = {
  Metadata: 'metadata',
  Vitality: 'vitality',
  Interfaces: 'interfaces',
  Hardware: 'hardware',
  Connections: 'connections',
  RoutingProtocols: 'routing-protocols',
  MPLS: 'mpls',
  VPN: 'vpn',
  TrafficAnalysis: 'traffic-analysis',
  TransceiverOptics: 'transceiver-optics',
  InterfaceClassification: 'interface-classification',
  QualityOfService: 'qos',
  VRF: 'vrf',
  WirelessLAN: 'wireless-lan',
  PowerDistribution: 'power-distribution',
  BatteryHealth: 'battery-health',
  DiskStats: 'disk-stats',
  Virtualization: 'virtualization',
  SecurityPolicies: 'security-policies',
  SDWANOverlay: 'sd-wan-overlay',
  IPSLA: 'ipsla',
  TelemetryCollection: 'telemetry-collection'
};

const DeviceClassToCapabilities = {
  [AllDeviceClass.Router]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.RoutingProtocols,
    DeviceCapability.MPLS,
    DeviceCapability.VPN,
    DeviceCapability.TrafficAnalysis,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.InterfaceClassification,
    DeviceCapability.QualityOfService,
    DeviceCapability.VRF,
    DeviceCapability.SecurityPolicies,
    DeviceCapability.IPSLA,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.Switch]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.MPLS,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.InterfaceClassification,
    DeviceCapability.QualityOfService,
    DeviceCapability.VRF,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.Firewall]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.RoutingProtocols,
    DeviceCapability.MPLS,
    DeviceCapability.VPN,
    DeviceCapability.TrafficAnalysis,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.InterfaceClassification,
    DeviceCapability.VRF,
    DeviceCapability.SecurityPolicies,
    DeviceCapability.IPSLA,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.LoadBalancer]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.MPLS,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.SdwanGateway]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.RoutingProtocols,
    DeviceCapability.MPLS,
    DeviceCapability.VPN,
    DeviceCapability.TrafficAnalysis,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.InterfaceClassification,
    DeviceCapability.QualityOfService,
    DeviceCapability.VRF,
    DeviceCapability.SecurityPolicies,
    DeviceCapability.SDWANOverlay,
    DeviceCapability.IPSLA,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.WirelessController]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.TransceiverOptics,
    DeviceCapability.WirelessLAN,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.AccessPoint]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.WirelessLAN,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.Server]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.DiskStats,
    DeviceCapability.Virtualization,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.UPS]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.PowerDistribution,
    DeviceCapability.BatteryHealth,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.PDU]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.PowerDistribution,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.OpticalTransport]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.MPLS,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.NetworkInterfaceDevice]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.Interfaces,
    DeviceCapability.Hardware,
    DeviceCapability.Connections,
    DeviceCapability.MPLS,
    DeviceCapability.TelemetryCollection
  ],
  [AllDeviceClass.StorageArray]: [
    DeviceCapability.Metadata,
    DeviceCapability.Vitality,
    DeviceCapability.DiskStats,
    DeviceCapability.TelemetryCollection
  ]
};

// eslint-disable-next-line import/no-commonjs
module.exports = {
  AllDeviceClass,
  AllDeviceClassLabel,
  NmsDeviceClassLabel,
  NonNmsDeviceClass,
  NonNmsDeviceClassLabel,
  getDeviceClassFilterOptions,
  DeviceClassToCapabilities,
  DeviceCapability
};
